import axios from 'axios'
import { Dispatch, SetStateAction } from 'react'
import 'regenerator-runtime/runtime'

const messages = {
    erreur: "connexion impossible"
}

class Postier{

    getMesures(token:string,client:string,site:string,setMesures, setErrors: Dispatch<SetStateAction<string[]>>){
        axios.get(`api-v0/mesures/${client.split(":")[3]}/${site.split(':')[0]}`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setMesures(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Les mesures ne peuvent pas être récupérées"])
            localStorage.clear()
            // location.reload()
        })

    }

    updateMesures(token:string,data:any,client, setErrors: Dispatch<SetStateAction<string[]>>){

        console.log({client})

        axios.post(`/api-v0/update/mesures/${client.split(":")[3]}`,data,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setErrors((errors: string[]) => [...errors, "Modification réussie"])
                // location.reload()
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "La modification a échoué"])
        })

    }

    getTypes(token:string,setMesures, setErrors: Dispatch<SetStateAction<string[]>>){
        axios.get(`/api-v0/mesurestypes/${localStorage.getItem('apiId')}/${localStorage.getItem('client').split(':')[3]}`,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setMesures(res.data)
        }).catch(err=>{
            setErrors((errors: string[]) => [...errors, "Les mesures types ne peuvent pas être récupérées"])
            localStorage.clear()
            // location.reload()
        })

    }

    createMesure(token: string, data: any, setPagina,setMesures, setErrors: Dispatch<SetStateAction<string[]>>){
        axios.post(`/api-v0/entity/create`,data,{headers:{ Authorization: `Bearer ${token}` }})
            .then(res=>{
                setErrors((errors: string[]) => [...errors, "Mesure créée"])
                res.data && setMesures(res.data)
                setPagina('main')
                location.reload()
        }).catch(err=>{
            console.log({err})
            setErrors((errors: string[]) => [...errors, "Les mesures ne peuvent pas être créées"])
        })

    }


}

export const postier = new Postier()